import { motion } from "framer-motion";

import { styles } from "../styles";
import { SectionWrapper } from "../hoc";
import { slideIn } from "../utils/motion";
import { Button } from "@mui/material";
import { Email, GitHub } from "@mui/icons-material";

const Contact = () => {
  return (
    <>
      <div style={{ marginTop: "-100px" }} className="flex flex-col-reverse gap-10 overflow-hidden md:flex-row-reverse ">
        <motion.div
          variants={slideIn("left", "tween", 0.1, 0.5)}
          className="flex-[0.75] rounded-2xl bg-black-100 p-8"
        > 
          <p className={styles.sectionSubText}>Get in touch</p>
          <h3 className={styles.sectionHeadText}>Contact me</h3>
          <div className="flex-center-center gap-2 mt-8 flex-wrap">
            <div>
              <a href="mailto:dtranhung@icloud.com">
                <Button variant="outlined" endIcon={<Email />}>
                  Email
                </Button>
              </a>
            </div>
            <div>
              <a
                href="https://github.com/hungdannt"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button variant="outlined" endIcon={<GitHub />}>
                  GitHub
                </Button>
              </a>
            </div>
            <div>
              <a
                href="https://www.upwork.com/freelancers/~0199da86ff25cda0b3"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button variant="outlined">
                  Upwork
                </Button>
              </a>
            </div>
          </div>
        </motion.div>

        <motion.div
          variants={slideIn("right", "tween", 0.1, 0.5)}
          className="md:h-auto md:flex-1"
        >
        </motion.div>
      </div>
      <div className="mb-6 flex justify-center">
        <h1 className="text-center text-sm font-light text-slate-200">
          Made with <span className="text-red-500">❤</span> by{" "}
          <a
            href="https://github.com/hungdannt"
            target="_blank"
            rel="noopener noreferrer"
            className="font-medium text-blue-400 hover:text-blue-500 hover:underline transition duration-300"
          >
            Dan Tran 
          </a> ©2025 
        <span className="text-[#46AEF0]">&nbsp;|| built with ReactJS + TailwindCSS</span>
        </h1>
      </div>
      <hr className="ml-2" />
    </>
  );
};

export default SectionWrapper(Contact, "contact");
